import ButtonSwitcher from "@components/Switchers/ButtonSwitcher/ButtonSwitcher"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {HeroSubSectionType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import {AnimatePresence, motion} from "framer-motion"
import {useRef} from "react"

import styles from "./HeroSubSection.module.scss"

type Theme = "studio" | "slide1" | "slide2"

type Props = {
	items?: HeroSubSectionType[]
	className?: string
	theme?: Theme
}

const HeroSubSection = ({items, className, theme}: Props) => {
	const isFirstRender = useRef(true)

	if (!items?.length) return null

	return (
		<div
			className={`${styles.subSection} ${theme ? styles.themed : ""} ${
				className ?? ""
			}`}
		>
			<AnimatePresence mode={"sync"}>
				{theme && (
					<motion.div
						key={theme}
						aria-hidden
						className={`${styles.subSectionBackground} ${styles[theme]}`}
						initial={{opacity: isFirstRender.current ? 1 : 0}}
						animate={{opacity: 1}}
						exit={{opacity: 0}}
						transition={{
							duration: isFirstRender.current ? 0 : 0.8,
							ease: "easeInOut",
						}}
						onAnimationComplete={() => {
							isFirstRender.current = false
						}}
					/>
				)}
			</AnimatePresence>
			{items.map((item, index) => (
				<div
					className={`${styles.column} ${
						index === 1 ? styles.columnSecond : ""
					}`}
					key={item.id}
				>
					<div className={styles.columnInner}>
						<div className={styles.textWrapper}>
							<Typography
								as={"h3"}
								className={styles.cardTitle}
								content={item.title}
								fontWeight={600}
								noPadding
								size={Size.XS}
								variant={Variant.Title}
							/>
							<Typography
								className={styles.cardDescription}
								content={item.description}
								fontWeight={300}
								noPadding
								size={Size.XS}
								variant={Variant.Description}
							/>
						</div>
						{item.buttons?.[0] && (
							<div className={styles.cardButtons}>
								<ButtonSwitcher
									buttonsList={{buttons: item.buttons}}
									withoutTarget
								/>
							</div>
						)}
					</div>
				</div>
			))}
		</div>
	)
}

export default HeroSubSection
